import axios from 'axios'
import { EXCLUIR_DESCONTO_USUARIO_ROTA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirDescontoUsuario (idDescontoUsuarioRota, idEmpresa) {
  const url = `${URL}/desconto-usuario-rota/${idDescontoUsuarioRota}/empresa/${idEmpresa}/excluir`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_DESCONTO_USUARIO_ROTA,
        payload: response

      })
  );
}
